import { FilterBaseModel } from './filter-base.model';

export class CommandeRepasFilterModel extends FilterBaseModel {
    isPiqueNique: boolean;
}